module.exports = __webpack_public_path__ + "static/docbrij.1afe1dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docbrij.jpg
// module id = 304
// module chunks = 58411574672382 144251824217401